<template>
  <div class="p-container">
    <header class="p-top">
      <img src="./assets/img/logo.png" />
      <p><span>福建金汉客制化定制</span></p>
    </header>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
  data() {
    return {
    }
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.p-container {
  // background: url('./assets/img/body_bg.png') no-repeat fixed;
  background-color: #F5F5F5;
  background-size: 100% auto;
// background: url('./assets/img/body_bg.png') no-repeat 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1440px;
  .p-top {
    position: sticky;
    z-index: 10000;
    top: 0;
    background: #fff;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 80px;
    img {
      // width: 100%;
      height: 80px;
    }
    p {
      flex: 1;
      height: 100%;
      background: #A60000;
      // color: #FDFAFA;
      color: rgba(253,250,250, 0.95);
      font-size: 30px;
      line-height: 80px;
      span {
        line-height: 80px;
        margin-left: 27vw;
        letter-spacing: 1px;
        font-weight: 560;
        font-family:"Times New Roman",Times,serif;
      }
    }
  }
}
::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        cursor: pointer;
      }
      ::-webkit-scrollbar-track {
        background-color: #fff;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        cursor: pointer;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #DFCDCD;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        cursor: pointer !important;
      }
</style>
